import { render, staticRenderFns } from "./consent-collection-privacy-policy-card.vue?vue&type=template&id=5eade45c"
import script from "./consent-collection-privacy-policy-card.vue?vue&type=script&lang=js"
export * from "./consent-collection-privacy-policy-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports